import { DirectedGraph } from "directed-graph-typed";

/*
    Dish {
        allergeni: { allergenID: String, allergenActive: Bool },
        available: Bool,
        categoryKey: String,
        description: String,
        descriptionEN: String,
        itemKey: String,
        name: String,
        nameEN: String,
        pos: Int,
        price: Float,
        restaurantKey: String,
        frozen: Bool,
        variants: { itemKey: String, reserved: Bool }?
    }
*/

/*
*   - Initializes an empty `DirectedGraph` containing a single node with identifier `root`
*   - Adds every dish and every dish variant to the graph with {key, value} = {the dish ID, the dish position}
*   - Links every dish to its children
*   - Adds every dish with no inbound links to `root` children
*
*    @parameter{dishesInThisCategory}: A linear array of the sorted (by position) `Dish` objects for this category
*    
*    @Returns: A `DirectedGraph` whose root item has 'root' key, representing the relationships between the dishes in this category.
*/
export const makeDishesGraphForCategory = (dishesInThisCategory) => {
    const dishesGraph = new DirectedGraph()

    dishesGraph.addVertex('root', 0)

    dishesInThisCategory.forEach(dish => {
        dishesGraph.addVertex(dish.itemKey, dish.pos)
    })

    dishesInThisCategory.forEach(dish => {
        if (dish.hasOwnProperty("variants")) {
            Object.keys(dish.variants).forEach((variantID) => {
                dishesGraph.addEdge(
                    /*sourceKey:*/dish.itemKey, 
                    /*destKey:*/ variantID, 
                    /*weight:*/ 1
                )
            })
        }
    })

    dishesInThisCategory.forEach(dish => {
        if (dishesGraph.incomingEdgesOf(dish.itemKey) <= 0) {
            dishesGraph.addEdge(
                /*sourceKey:*/'root', 
                /*destKey:*/ dish.itemKey, 
                /*weight:*/ 1
            )
        }
    })

    return dishesGraph
} 